export const SET_EDITORS = 'EDITORS/SET_EDITORS'
export const ADD_EDITOR = 'EDITORS/ADD_EDITOR'
export const REMOVE_EDITOR = 'EDITORS/REMOVE_EDITOR'
export const UPDATE_EDITOR = 'EDITORS/UPDATE_EDITOR'
